<template>
    <div class="dv5-card" v-if="view.length == 1 || subItem == true">
        <div class="social_logo">
            <img class="defaul_image" v-if="!subItem" :src="`${SocialNetwork}${view[0].type}.svg`">
            <img class="group_image" v-else-if="subItem" :src="`${SocialNetwork}${view.type}_group.svg`">
        </div>
        <div class="social_content" v-if="!subItem">
            <div><img v-for="(people, index) in randomPeopple" :key="people" :src="`${PeoppleRoute}${people}.svg`"></div>
            <div><span>{{ translations.onboarding_social_text + social }}</span></div>
        </div>
        <div class="social_content" v-else-if="subItem">
            <div><span>{{ view.title }}</span></div>
            <div><img v-for="(people, index) in randomPeopple" :key="people" :src="`${PeoppleRoute}${people}.svg`"></div>
        </div>
        <div class="bnt_general">
            <div v-if="social != 'youtube'" class="btn_follow" @click="follow()" :class="{ 'is-active': isFollowing }">+ {{ translations.onboarding_collapse_follow }}</div>
            <div v-else-if="social == 'youtube'" class="btn_follow" @click="follow()" :class="{ 'is-active': isFollowing }">+ {{ translations.onboarding_collapse_subscribe }}</div>
        </div>
    </div>
    <div class="card_colapse" v-else-if="view.length > 1">
        <div class="dv5-card">
            <div class="social_logo">
                <img class="defaul_image" :alt="view[0].type" :src="`${SocialNetwork}${view[0].type}.svg`">
            </div>
            <div class="social_content">
                <div><img v-for="(people, index) in randomPeopple" :key="people" :src="`${PeoppleRoute}${people}.svg`"></div>
                <div><span>{{ translations.onboarding_social_text + social }}</span></div>
            </div>
            <div class="bnt_general">
                <div v-if="!collapsed" class="btn_follow" @click="collpaseToggle" :class="{ 'is-active': isFollowing }">+ {{ translations.onboarding_collapse_open }}</div>
                <div v-else-if="collapsed" class="btn_follow" @click="collpaseToggle" :class="{ 'is-active': isFollowing }">+ {{ translations.office_reviews_btn_close }}</div>
            </div>
        </div>
        <div class="dv5-collapse-content section" :class="{ 'collapsed': !collapsed }">
            <social-component v-for="(data, index) in view" :key="index" :view="data" :translations="translations" :subItem="true"/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'social-component',
    props: {
        view: null,
        translations: {
            type: Object,
        },
        subItem: false,
        social: null
    },
    data: function() {
        return {
            PeoppleRoute: '/internacional/public/office5/img/onboarding/random_people/random_people_',
            SocialNetwork: '/internacional/public/office5/img/onboarding/social_network/',
            randomPeopple: [],
            isFollowing: false,
            collapsed: false,
            windowWidth: window.innerWidth,
            numOfPeople: 5
        }
    },
    mounted() {
        this.onResize()
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        _sortear() {
            var numeros = []
            while (numeros.length < this.numOfPeople) {
                var aleatorio = Math.floor(Math.random() * 15);

                if (numeros.indexOf(aleatorio) == -1)
                    numeros.push(aleatorio);
            }
            this.randomPeopple = numeros
        },
        follow() {
            if (this.subItem) {
                window.open(`${this.view.link}`, '_blank')
            } else if (!this.subItem) {
                window.open(`${this.view[0].link}`, '_blank')
            }
            this.isFollowing = !this.isFollowing
        },
        collpaseToggle(){
            this.collapsed = !this.collapsed
        },
        onResize() {
            this.windowWidth = window.innerWidth
            if (this.windowWidth < 1680 && this.windowWidth > 1366) {
                this.numOfPeople = 4
                this._sortear()
            } else if (this.windowWidth <= 1366) {
                this.numOfPeople = 3
                this._sortear()
            } else {
                this.numOfPeople = 5
                this._sortear()
            }
        },
    },
    watch: {
        "view.externalCollapse": {
            handler: function(newVal, oldVal) {
                this.collapsed = newVal
            },
            deep: true
        }
    }
}
</script>

<style scoped lang="scss">
@import '../../../../scss/extras/_variables';
.dv5-card {
    font: inherit;
    display: inline-grid;
    grid-template-columns: 1fr 5fr 1.7fr;
    grid-template-rows: 4.5rem;

    margin: .3em 0;
    padding: .5rem 2rem .5em 1em;
    width: 100%;
    height: auto;

    border-radius: 8px;
    background-color: $dv5-color4;

    .social_content,
    .social_logo,
    .bnt_general {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .social_logo {
        .group_image {
            height: 75% !important;
        }
        .defaul_image {
            height: 100%;
        }
    }
    .social_content {
        display: flex;
        justify-content: space-around;
        margin: 0 2%;
        div {
            display: flex;
            img {
                margin-left: -1em;
                height: 80%;
            }
            span {
                font-size: 1.1rem;
                font-family: 'Muli';
                font-weight: 900;
                text-transform: capitalize;
            }
        }
    }
    .bnt_general {

        .btn_follow {
            display: flex;
            align-items: center;
            justify-content: center;

            text-transform: capitalize;
            font-family: 'Muli';
            font-weight: 900;

            width: 90%;
            height: 70%;
            color: $dv5-color1;
            background: #EBF2FA;
            border-radius: 4px;
            cursor: pointer;

            &.is-active {
                background: $dv5-color1;
                color: #FFF;
            }
        }
    }
}
@media (max-width: 1366px) {
    .dv5-card{
        grid-template-columns: 1fr 5fr 1.7fr;
        padding: .5em 1em;

        .social_content {
            margin: 0 0 0 0%;
            justify-content: left;

            div > img {
                display: none;
            }
        }

        .social_logo {
            .defaul_image {
                height: 70%;
            }
            .group_image {
                height: 40% !important;
            }
        }
    }
}
.card_colapse {
    display: flex;
    flex-direction: column;

    width: 100%;
    height: auto;

    border-radius: 8px;
    background-color: transparent;
    .dv5-collapse-content{
        font: inherit;
    }
}
.section {
    overflow:hidden;
    transition:max-height .8s;
    height:auto;
    max-height: 1800px;
    max-width: 98%;
    margin: 0 1%;
}
.section.collapsed {
    transition: .8s;
    max-height:0;
    padding: 0 0 !important;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/onboarding/SocialComponent.vue